import { createSlice } from '@reduxjs/toolkit';
import { getPlans, comparePlans, getActiveSubscription, getAppConfig, syncPayment, downloadInvoice } from './plansAction';

const initialState = {
  plans: [],
  comparisonData: null,
  activeSubscription: null,
  appConfig: null,
  paymentStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  isLoading: false,
  isLoaded: false, // Flag to track if subscription check has been performed
  isComparing: false,
  error: null,
};

const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlans.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.plans = action.payload || [];
      })
      .addCase(getPlans.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(comparePlans.pending, (state) => {
        state.isComparing = true;
        state.error = null;
      })
      .addCase(comparePlans.fulfilled, (state, action) => {
        state.isComparing = false;
        state.comparisonData = action.payload;
      })
      .addCase(comparePlans.rejected, (state, action) => {
        state.isComparing = false;
        state.error = action.payload;
      })
      .addCase(getActiveSubscription.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getActiveSubscription.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoaded = true;
        state.activeSubscription = action.payload;
      })
      .addCase(getActiveSubscription.rejected, (state, action) => {
        state.isLoading = false;
        state.isLoaded = true;
        state.error = action.payload;
      })
      .addCase(getAppConfig.fulfilled, (state, action) => {
        state.appConfig = action.payload;
      })
      .addCase(syncPayment.pending, (state) => {
        state.paymentStatus = 'loading';
        state.error = null;
      })
      .addCase(syncPayment.fulfilled, (state) => {
        state.paymentStatus = 'succeeded';
      })
      .addCase(syncPayment.rejected, (state, action) => {
        state.paymentStatus = 'failed';
        state.error = action.payload;
      })
      .addCase(downloadInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(downloadInvoice.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(downloadInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default plansSlice.reducer;
